import type * as Types from 'connect-graphql/generated';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserAvatarQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  size: Types.Scalars['Int']['input'];
  includeBlur: Types.Scalars['Boolean']['input'];
}>;


export type UserAvatarQuery = { __typename?: 'Query', avatar: { __typename?: 'Avatar', fullName: string, initials: string, url?: string | null, blurDataUrl?: string | null } };


export const UserAvatarDocument = gql`
    query UserAvatar($userId: ID!, $size: Int!, $includeBlur: Boolean!) {
  avatar(id: $userId) {
    fullName
    initials
    url(size: $size)
    blurDataUrl @include(if: $includeBlur)
  }
}
    `;

export function useUserAvatarQuery(options: Omit<Urql.UseQueryArgs<UserAvatarQueryVariables>, 'query'>) {
  return Urql.useQuery<UserAvatarQuery, UserAvatarQueryVariables>({ query: UserAvatarDocument, ...options });
};